// extracted by mini-css-extract-plugin
export default {"list":"InfiniteScroll-module__list__cbD15","loader":"InfiniteScroll-module__loader__ULo+g"};